import DefaultValidation from '@/services/validations/DefaultValidation';
import * as Util from '@/functions/Util';
import * as InscricaoEstadual from '@/functions/IEValidation';

export default class EmpresaGeralValidation extends DefaultValidation {
    validate(model, refs, abrev, required) {
        let validated = true;

        if (Util.isNull(model.idempresaerp)) {
            refs.codigoInput.focusedOut = true;
            validated = false;
        }

        if (Util.isNull(model.nome)) {
            refs.nomeInput.focusedOut = true;
            validated = false;
        }

        if (required.rsocial.includes(abrev) && Util.isNull(model.rsocial)) {
            refs.razaosocialInput.focusedOut = true;
            validated = false;
        }

        if (
            (required.cnpj.includes(abrev) && Util.isNull(model.cnpj)) ||
            (!Util.isNull(model.cnpj) && !Util.validateCnpj(model.cnpj))
        ) {
            refs.cnpjInput.focusedOut = true;
            validated = false;
        }

        if (
            ((required.ie.includes(abrev) && Util.isNull(model.ie)) ||
            (!Util.isNull(model.ie) && !InscricaoEstadual.validateIE(model.ie, model.uf))) && model.ie != "ISENTO"
        ) {
            refs.ieInput.focusedOut = true;
            validated = false;
        }

        if (
            (required.porcentagemestipulada.includes(abrev) &&
                Util.isNull(model.porcentagemestipulada)) ||
            (!Util.isNull(model.porcentagemestipulada) &&
                !Util.validatePorcentagem(model.porcentagemestipulada))
        ) {
            refs.porcentagemestipuladaInput.focusedOut = true;
            validated = false;
        }

        if (
            (required.cep.includes(abrev) && Util.isNull(model.cep)) ||
            (!Util.isNull(model.cep) && !Util.validateCEP(model.cep))
        ) {
            refs.cepInput.focusedOut = true;
            validated = false;
        }

        if (required.cidade.includes(abrev) && Util.isNull(model.cidade)) {
            refs.cidadeInput.focusedOut = true;
            validated = false;
        }

        if (required.bairro.includes(abrev) && Util.isNull(model.bairro)) {
            refs.bairroInput.focusedOut = true;
            validated = false;
        }

        if (required.endereco.includes(abrev) && Util.isNull(model.endereco)) {
            refs.enderecoInput.focusedOut = true;
            validated = false;
        }

        if (required.numero.includes(abrev) && Util.isNull(model.numero)) {
            refs.numeroInput.focusedOut = true;
            validated = false;
        }

        if (
            (required.latitude.includes(abrev) && Util.isNull(model.latitude)) ||
            (!Util.isNull(model.latitude) && !Util.validateLatitude(model.latitude))
        ) {
            refs.latitudeInput.focusedOut = true;
            validated = false;
        }

        if (
            (required.longitude.includes(abrev) && Util.isNull(model.longitude)) ||
            (!Util.isNull(model.longitude) && !Util.validateLongitude(model.longitude))
        ) {
            refs.longitudeInput.focusedOut = true;
            validated = false;
        }

        if (
            (required.telefone.includes(abrev) && Util.isNull(model.telefone)) ||
            (!Util.isNull(model.telefone) && !Util.validatePhone(model.telefone))
        ) {
            refs.telefoneInput.focusedOut = true;
            validated = false;
        }

        if (
            (required.telefone_celular.includes(abrev) && Util.isNull(model.telefone_celular)) ||
            (!Util.isNull(model.telefone_celular) && !Util.validatePhone(model.telefone_celular))
        ) {
            refs.celularInput.focusedOut = true;
            validated = false;
        }

        if (!Util.isNull(model.paginaweb) && !Util.validateURL(model.paginaweb)) {
            refs.paginawebInput.focusedOut = true;
            validated = false;
        }

        if (
            (required.email1.includes(abrev) && Util.isNull(model.email1)) ||
            (!Util.isNull(model.email1) && !Util.validateEmail(model.email1))
        ) {
            refs.email1Input.focusedOut = true;
            validated = false;
        }

        if (!Util.isNull(model.email2) && !Util.validateEmail(model.email2)) {
            refs.email2Input.focusedOut = true;
            validated = false;
        }

        return validated;
    }
}
